import { motion } from "framer-motion";

type Props = {
  backgroundColor: string;
  height: string;
};

const cursorVariants = {
  blinking: {
    opacity: [0, 0, 1, 1],
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatDelay: 0,
      ease: "linear",
      times: [0, 0.5, 0.5, 1],
    },
  },
};

export default function CursorBlinker({ backgroundColor, height }: Props) {
  return (
    <motion.div
      variants={cursorVariants}
      animate="blinking"
      style={{
        display: "inline-block",
        height: height,
        width: "1px",
        transform: "translateY(0.25rem)",
        backgroundColor: backgroundColor,
      }}
    />
  );
}
